const STORAGE_KEY = "ima_erp_device_fp_v1";

/** Định danh thiết bị ổn định (localStorage) — dùng khi đăng nhập để áp giới hạn thiết bị (GV đối tác). */
export function getOrCreateDeviceFingerprint() {
  try {
    let v = localStorage.getItem(STORAGE_KEY);
    if (!v || String(v).trim().length < 8) {
      v =
        typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
          ? crypto.randomUUID()
          : `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
      localStorage.setItem(STORAGE_KEY, v);
    }
    return String(v).trim();
  } catch {
    return `fallback-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }
}

/**
 * Phân loại thiết bị đăng nhập: desktop (máy tính) | mobile (điện thoại).
 * Dùng cùng quy tắc với backend để giới hạn 1 máy tính + 1 điện thoại.
 */
export function getDeviceClass() {
  try {
    if (typeof window !== "undefined" && window.matchMedia) {
      // Ưu tiên viewport hẹp / coarse pointer ≈ điện thoại / tablet
      const coarse = window.matchMedia("(pointer: coarse)").matches;
      const narrow = window.matchMedia("(max-width: 900px)").matches;
      if (coarse && narrow) return "mobile";
    }
    const ua = typeof navigator !== "undefined" ? navigator.userAgent || "" : "";
    if (
      /mobile|android|iphone|ipod|webos|blackberry|iemobile|opera mini|ipad/i.test(
        ua
      )
    ) {
      return "mobile";
    }
  } catch {
    /* ignore */
  }
  return "desktop";
}
